// extracted by mini-css-extract-plugin
export var container = "SubHeader-module--container--1I-Xp";
export var content = "SubHeader-module--content--2kCnr";
export var gallery = "SubHeader-module--gallery--1xXh0";
export var item = "SubHeader-module--item--F14xj";
export var itemText = "SubHeader-module--itemText--3OGb8";
export var decorated = "SubHeader-module--decorated--3z67j";